export interface IAuth0User {
  id: string;
  picture: string;
  name: string;
}

export interface IAuth0UserApiModel {
  user_id: string;
  picture: string;
  name: string;
}

export default class Auth0User implements IAuth0User {
  public readonly id: string;

  public readonly picture: string;

  public readonly name: string;

  constructor(id: string, picture: string, name: string) {
    this.id = id;
    this.picture = picture;
    this.name = name;
  }

  static fromApiModel(apiModel: IAuth0UserApiModel) {
    const { user_id, picture, name } = apiModel;

    return new Auth0User(user_id, picture, name);
  }

  static arrayFromApiModel(arrayApiModel: IAuth0UserApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      return this.fromApiModel(apiModel);
    });

    return array;
  }
}
